export class TimeoutError extends Error {
	readonly code: string;

	constructor(message: string) {
		super(message);
		this.name = 'TimeoutError';
		this.code = 'deadline-exceeded';
	}
}
